export default __webpack_public_path__ + "b24fb982663a39a7e1f4b15cebb3532d.jpg";